import { SecondaryButton } from '@luminalearning/components';
import { useIntl } from 'react-intl';
import env from 'src/env';

const MeetingCard = () => {
    const intl = useIntl();

    return (
        <div className={
            ['invisible h-auto lg:visible relative overflow-hidden flex flex-row mr-8 mt-8',
                'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                'hover:border-card-hover active:shadow-none']
                .join('')}
        style={{
            width: '60rem',
        }}
        >
            <div className='border-1-5 z-30 bg-white pl-10 pt-10 ' style={{
                width: '40rem',
            }}>
                <div className='flex flex-col  w-search'>
                    <h1 className='text-headline-reg font-bold mb-6'>
                        {
                            intl.formatMessage({
                                id: 'LP_BOOK_MEETING_WITH_US',
                                defaultMessage: 'Book a meeting with us',
                            })
                        }
                    </h1>
                    <p className='text-paragraph-reg'>
                        {
                            intl.formatMessage({
                                id: 'LP_BOOK_MEETING_DESC',
                                defaultMessage: 'Want to discuss something with us in more detail? Use our meeting booking system to find a time that works for you',
                            })
                        }
                    </p>
                    <a href={env.hubspotBookMeetingUrl} target='_blank' rel='noopener noreferrer'>
                        <SecondaryButton
                            text='Book a meeting'
                            hasArrow={true}
                            direction='Right'
                            onClick={() => { /** noop */ }}
                            className='mt-6 mb-6 w-9'
                        />
                    </a>
                </div>

            </div>
            <img src='/img/VirtualWorkshop.png'
                alt={intl.formatMessage({ id: 'LP_ALT_VIRTUAL_WORKSHOP', defaultMessage: 'Virtual Workshop' })}
                className='absolute -bottom-52 -right-80 w-90 mb-16 border-1-5 ' />

        </div>
    );
};

export default MeetingCard;